'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('client-settings-edit', {
      url: '/admin/client/edit',
      template: '<client-settings-edit></client-settings-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/client-edit/client-edit.routes.js